<template>
  <div class="loading">Loading&#8230;</div>
</template>

<script>
export default {
  name: "loading",
};
</script>
